<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>UI FRAMEWORKS</div>
				<h2 waHeading="l" waText>Supported UI Frameworks</h2>
				<p waBody="m" waColorText="quiet" waText>Production-ready component libraries &mdash; pick the one that fits your project.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<markdown [data]="mdContent_43"></markdown>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="brand">5 Frameworks</wa-tag>
					<wa-tag pill variant="success">CRTP Fluent APIs</wa-tag>
					<wa-tag pill variant="neutral">Zero Config</wa-tag>
				</div>
			</div>
		</div>
		<div class="wa-grid wa-gap-l" style="--min-column-size:20rem;">
			<wa-card appearance="outlined" id="webawesome">
				<div class="wa-stack wa-gap-s">
					<h2 waHeading="l" waText>WebAwesome</h2>
					<p waBody="m" waColorText="quiet" waText>Modern, accessible web component library</p>
					<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>WebAwesome 1.0</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
					</div>
					<wa-button [routerLink]="['/frameworks/web-awesome']" appearance="outlined" variant="brand">Explore Components</wa-button>
				</div>
			</wa-card>
			<wa-card appearance="outlined" id="webawesome-pro">
				<div class="wa-stack wa-gap-s">
					<h2 waHeading="l" waText>WebAwesome Pro</h2>
					<p waBody="m" waColorText="quiet" waText>Premium WebAwesome plugin</p>
					<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>WebAwesome 1.0</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
					</div>
					<wa-button [routerLink]="['/frameworks/web-awesome-pro']" appearance="outlined" variant="brand">Explore Components</wa-button>
				</div>
			</wa-card>
			<wa-card appearance="outlined" id="bootstrap">
				<div class="wa-stack wa-gap-s">
					<h2 waHeading="l" waText>Bootstrap</h2>
					<p waBody="m" waColorText="quiet" waText>Bootstrap 5.3.8</p>
					<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Bootstrap 5.3.8</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Bootstrap 5.3.8</wa-tag>
						<wa-tag pill variant="neutral">ng-bootstrap 20</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
					</div>
					<wa-button [routerLink]="['/frameworks/bootstrap']" appearance="outlined" variant="brand">Explore Components</wa-button>
				</div>
			</wa-card>
			<wa-card appearance="outlined" id="angular-material">
				<div class="wa-stack wa-gap-s">
					<h2 waHeading="l" waText>Angular Material</h2>
					<p waBody="m" waColorText="quiet" waText>Angular Material 19.1.4</p>
					<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Angular Material 19.1.4</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Angular Material 19.1.4</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
					<wa-button [routerLink]="['/frameworks/angular-material']" appearance="outlined" variant="brand">Explore Components</wa-button>
				</div>
			</wa-card>
			<wa-card appearance="outlined" id="jquery-ui">
				<div class="wa-stack wa-gap-s">
					<h2 waHeading="l" waText>jQuery UI</h2>
					<p waBody="m" waColorText="quiet" waText>jQuery UI 1.14.2</p>
					<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>jQuery UI 1.14.2</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">jQuery UI 1.14.2</wa-tag>
						<wa-tag pill variant="neutral">jQuery 4.0.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
					</div>
					<wa-button [routerLink]="['/frameworks/jquery-ui']" appearance="outlined" variant="brand">Explore Components</wa-button>
				</div>
			</wa-card>
		</div>
	</div>
</div>